import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Four04Component } from './four04/four04.component';

@NgModule({
  declarations: [
    Four04Component
  ],
  imports: [
    CommonModule
  ],
  exports: [
    Four04Component
  ]
})
export class StatuscodesModule { }
